import OperatorIntegrationShow from './wallet-integration.show';
import OperatorIntegrationEdit from './wallet-integration.edit';

export default {
  show: OperatorIntegrationShow,
  edit: OperatorIntegrationEdit,
};
